export default {
  title: 'Faktury',
  form: {
    auto_generate_invoices: {
      label: 'Automatyczne generowanie faktur',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
